import { FC, ReactElement } from 'react';
import SlickSlider, { Settings } from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './slider.css';

type SliderProps = { children: ReactElement[] } & Partial<Omit<Settings, 'children'>>;

export const Slider: FC<SliderProps> = (props) => {
  const { children, ...sliderProps } = props;

  return (
    <div className="slider-container">
      <SlickSlider dots infinite speed={500} slidesToShow={5} {...sliderProps}>
        {children}
      </SlickSlider>
    </div>
  );
};

export default Slider;
